import { PaymentImage } from '@assets';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Box } from '@material-ui/core';
import { openFromBanner } from '@modules/modal';
import { useDispatch } from '@store';

const PaymentBanner = () => {
  const dispatch = useDispatch();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      padding="16px 16px 0 16px"
      style={{
        cursor: 'pointer'
      }}
      onClick={() => {
        dispatch(openFromBanner());
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gridGap={8}
        width="100%"
        bgcolor={colorSet.primary100}
        padding="6px 16px 6px 12px"
        borderRadius={12}
      >
        <img width={78} height={61} src={PaymentImage} alt="결제이미지" />
        <Box display="flex" flexDirection="column">
          <CustomizedTypography
            color="textPrimary"
            variant="body2"
            fontWeight="700"
          >
            캐파에서 거래 대금을 직접 결제하세요!
          </CustomizedTypography>
          <CustomizedTypography color="textSecondary" variant="subtitle2">
            거래의 시작부터 끝까지 안전하게!
          </CustomizedTypography>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentBanner;
